// extracted by mini-css-extract-plugin
module.exports = {"item":"a10a3f92e9--item--lMvlJ","row":"a10a3f92e9--row--qt1Ko","title":"a10a3f92e9--title--Sw2Mg","value":"a10a3f92e9--value--b1PYB"};